<template>
  <dx-offer-intro product="p-private" />
</template>

<script>
import DxOfferIntro from '~/domains/offer/components/DX-OfferIntro'

export default {
  name: 'PPrivateIntro',
  components: {
    DxOfferIntro,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  transition: 'none',
  meta: {
    isPublic: true,
    trackingId: 'dextra.privatrechtsschutz.p-private.antragsstrecke',
    trackingGroup: ['rechtsschutz', 'privatrechtsschutz'],
  },
  nuxtI18n: {
    paths: {
      de: '/privatrechtsschutz/p-private/antragsstrecke/',
      fr: '/protection-juridique-privee/p-private/formulaire-de-demande/',
    },
  },
}
</script>
